import type { resourceEventHistoryApiSpec } from "@wingspanhq/wingspan-api-types";
import startCase from "lodash/startCase";
import { formatAttributeValue } from "./formatAttributeValue";

type Props = {
  changes: resourceEventHistoryApiSpec.IAttributeChange[];
};

const AttributeChangeItem = (props: {
  change: resourceEventHistoryApiSpec.IAttributeChange;
}) => {
  const label = props.change.name || startCase(props.change.key);
  const hasBefore = props.change.beforeValue !== undefined;
  const hasAfter = props.change.afterValue !== undefined;

  return (
    <li>
      {label}
      <ul>
        <li>
          {hasBefore && (
            <span style={{ textDecoration: "line-through" }}>
              {formatAttributeValue(
                props.change.beforeValue!,
                props.change.type
              )}
            </span>
          )}
          {hasBefore && hasAfter && " → "}
          {hasAfter &&
            formatAttributeValue(props.change.afterValue!, props.change.type)}
        </li>
      </ul>
    </li>
  );
};

export const AttributeChanges = (props: Props) => {
  if (props.changes.length === 0) return null;

  return (
    <ul>
      {props.changes.map(change => (
        <AttributeChangeItem key={change.key} change={change} />
      ))}
    </ul>
  );
};
